import {Injectable, Injector} from "@angular/core";
import {ProductLineData} from "./product-line.data";
import {EntityModel} from "@fedeltapointofsale/data-client";

@Injectable()
export class ProductLineEntityModel extends EntityModel<ProductLineData> {

    constructor(injector: Injector) {
        super(injector, ProductLineData);
    }
}
